import type { CloudAPI } from '@yandex-360/telemost-sdk/cloud-api';

import { Role, RolePermission, RolePermissionMatrix, RolePermissionMatrixSlice } from '../../helpers/permissions';
import { CONSIDERED_MATRIX_ROLE_PERMISSIONS } from './constants';

export function getMatrixDiffRoles(
    matrix: RolePermissionMatrix,
    matrixOverride: RolePermissionMatrix
): CloudAPI.MatrixBodyRole[] {
    return Object.entries(matrixOverride).reduce((roles, entry) => {
        const [role, slice] = entry as [Role, RolePermissionMatrixSlice];

        if (matrix[role]) {
            const sliceDiff = Object.entries(slice).reduce((slc, ent) => {
                const [permission, value] = ent as [RolePermission, boolean];

                if (matrix[role]?.[permission] !== value) {
                    slc[permission] = value;
                }

                return slc;
            }, {} as RolePermissionMatrixSlice);

            roles.push({
                role,
                allowed: sliceDiff,
            });
        } else {
            roles.push({
                role,
                allowed: slice,
            });
        }

        return roles;
    }, [] as CloudAPI.MatrixBodyRole[]);
}

export function convertRolesToMatrix(roles: CloudAPI.MatrixRole[]) {
    return roles.reduce((mtrx, slice) => {
        const { role, allowed } = slice;
        const allowedSet = new Set(allowed);

        mtrx[role] = {};

        CONSIDERED_MATRIX_ROLE_PERMISSIONS.forEach((permission) => {
            mtrx[role]![permission] = allowedSet.has(permission);
        });

        return mtrx;
    }, {} as RolePermissionMatrix);
}
